import t from "../../shared/translations";
import type { AnswerType, TaskIcon, VariantType } from "../../shared/types";

interface IData {
    task: {
        icon: TaskIcon;
        name: string;
        taskVariants: {
            variantType: VariantType;
            variantTitle: string | null;
            description: string;
            eventStart: string | null;
            eventEnd: string | null;
            taskQuestions: {
                answerType: AnswerType;
                questionContent: string | null;
            }[];
        }[];
    };
    placeholders: {
        answer: string;
    };
    errors: {
        answer: string;
    };
}

export default function taskData(kind: string): IData {
    if (kind === "insight") {
        return {
            task: {
                icon: "bulb",
                name: t("player.customer-insight.name"),
                taskVariants: [
                    {
                        variantType: "basic",
                        variantTitle: null,
                        description: t("player.customer-insight.description"),
                        eventStart: null,
                        eventEnd: null,
                        taskQuestions: [
                            {
                                answerType: "textbox",
                                questionContent: null,
                            },
                        ],
                    },
                ],
            },
            placeholders: {
                answer: t("player.customer-insight.form-answer-placeholder"),
            },
            errors: {
                answer: t("player.customer-insight.form-answer-error"),
            },
        };
    }
    if (kind === "course") {
        return {
            task: {
                icon: "diploma",
                name: t("player.course.name"),
                taskVariants: [
                    {
                        variantType: "basic",
                        variantTitle: null,
                        description: t("player.course.description"),
                        eventStart: null,
                        eventEnd: null,
                        taskQuestions: [
                            {
                                answerType: "textbox",
                                questionContent: null,
                            },
                        ],
                    },
                ],
            },
            placeholders: {
                answer: t("player.course.form-answer-placeholder"),
            },
            errors: {
                answer: t("player.course.form-answer-error"),
            },
        };
    }
    return {
        task: {
            icon: "puzzle-piece",
            name: t("player.custom-task.name"),
            taskVariants: [
                {
                    variantType: "basic",
                    variantTitle: null,
                    description: t("player.custom-task.description"),
                    eventStart: null,
                    eventEnd: null,
                    taskQuestions: [
                        {
                            answerType: "textbox",
                            questionContent: null,
                        },
                    ],
                },
            ],
        },
        placeholders: {
            answer: t("player.custom-task.form-answer-placeholder"),
        },
        errors: {
            answer: t("player.custom-task.form-answer-error"),
        },
    };
}
